module.exports = __webpack_public_path__ + "static/media/astro_it.ff3c16d0.png";